<template>
    <div class="replacement-item">
        <span class="num">{{index + 1}}</span>
        <div class="inputs-block">
            <label class="file">
                <img v-if="itemInfo.pictureStrBase64" class="previewImage" :src="itemInfo.pictureStrBase64" alt="">
                <input type="file" @change="handleImage" accept="image/*">
            </label>
            <textarea v-model="itemInfo.comment" placeholder="Комментарий" name="comment"></textarea>
        </div>
    </div>
</template>

<script>
    export default{
        props: ['itemInfo', 'index'],
        data: () => ({}),
        methods: {
            // Загрузка изображений
            handleImage(e){
                const selectedImage = e.target.files[0];
                this.createBase64Image(selectedImage);
            },
            createBase64Image(fileObject){
                let self = this;
                const render = new FileReader();
                render.onload = (e) => {
                    this.itemInfo.pictureStrBase64 = e.target.result;
                }
                render.readAsDataURL(fileObject);
            }
        }
    }
</script>
<style lang="scss" scoped>
    .replacement-item{
        width: 100%;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
        position: relative;
        margin-bottom: 15px;
        padding: 10px;
        .num{
            width: 18px;
            height: 18px;
            background: #000;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            color: #fff;
            font-size: 12px;
        }
        .inputs-block{
            margin-top: 5px;
            display: flex;
            justify-content: space-between;
        }
        textarea{
            flex-grow: 2;
            margin-left: 10px;
            padding: 5px;
            font-size: 12px;
        }
        input[type="file"]{
            width: 1px;
            height: 1px;
            position: absolute;
            overflow: hidden;
            opacity: 0;
        }
        .file{
            width: 100px;
            height: 75px;
            margin: 0;
            position: relative;
            background-size: 80%;
            background-repeat: no-repeat;
            background-position: center;
            background-color: #C4C4C4;
            background-image: url('../../img/photoCamera.svg');
        }
        .previewImage{
            position: absolute;
            width: 100%;
            height: 100%;
        }
        .test{
            width: 50px;
            height: 50px;
        }
    }
</style>